import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, onSnapshot } from "firebase/firestore";

const SALE_CODE_WAIT_MS = 3000;

// BE-18: carts.sale_code lo escribe un trigger ~1 s después del pago, así que puede no venir en la
// respuesta del checkout. Se escucha solo el doc del carro, y solo mientras `enabled`. Si a los 3 s
// no llegó, `timedOut` avisa para mostrar un respaldo (external_order_id, si no numeric_id; regla
// común EPI-05); el código igual reemplaza al respaldo si aparece después.
export function useCartSaleCode(env, client, cartId, enabled) {
  const [saleCode, setSaleCode] = useState(null);
  const [externalOrderId, setExternalOrderId] = useState(null);
  const [numericId, setNumericId] = useState(null);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    setSaleCode(null);
    setExternalOrderId(null);
    setNumericId(null);
    setTimedOut(false);
    if (!enabled || !env || !client || !cartId) return () => [];

    const timer = setTimeout(() => setTimedOut(true), SALE_CODE_WAIT_MS);
    const ref = doc(db, "kiosk", env, "client", client, "carts", cartId);
    const unsub = onSnapshot(
      ref,
      (snapshot) => {
        const data = snapshot.exists() ? snapshot.data() : null;
        setSaleCode(data?.sale_code || null);
        setExternalOrderId(data?.external_order_id || null);
        setNumericId(data?.numeric_id ?? null);
      },
      (error) => {
        console.error("Error listening cart sale_code:", error);
      }
    );

    return () => {
      clearTimeout(timer);
      unsub();
    };
  }, [env, client, cartId, enabled]);

  return { saleCode, externalOrderId, numericId, timedOut };
}
